
import accordion from '@Shared/Common/Scripts/Components/accordionBase';
export default {
  components: {
    accordion: accordion
  }
};